import React from 'react';
import {InvoicesUIProvider} from "./InvoicesUIContext";
import {InvoicesCard} from "./InvoicesCard";
import {Route} from "react-router-dom";
import {InvoiceDeleteDialog} from "./invoice-delete-dialog/InvoiceDeleteDialog";

export function InvoicesPage({history}) {

    const invoicesUIEvents = {
        newInvoiceButtonClick: () => {
            history.push('/accounting/invoices/new');
        },
        viewInvoiceButtonClick: (id) => {
            history.push(`/accounting/invoices/${id}/view`);
        },
        deleteInvoiceButtonClick: (id) => {
            history.push(`/accounting/invoices/${id}/delete`);
        }
    }


    return (
        <InvoicesUIProvider invoicesUIEvents={invoicesUIEvents}>

            <Route path={"/accounting/invoices/:id/delete"}>
                {({history, match}) => (
                    <InvoiceDeleteDialog
                        show={match != null}
                        id={match && match.params.id}
                        onHide={() => history.push("/accounting/invoices")}
                    />
                )}
            </Route>
            
            

            <InvoicesCard/>

        </InvoicesUIProvider>
    )

}